import { email, password, required, Validator } from '@/entities/validation';
import { RegisteringUser } from './model';

export const validate: Validator<RegisteringUser> = user => [
  ...required(user.firstName, 'firstName'),
  ...required(user.lastName, 'lastName'),
  ...required(user.email, 'email'),
  ...email(user.email, 'email'),
  ...required(user.password, 'password'),
  ...password(user.password, 'password'),
];
